
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19 7.99998V11H5.82998L8.70998 8.11998C9.09998 7.72998 9.09998 7.09998 8.70998 6.70998C8.31998 6.31998 7.68998 6.31998 7.29998 6.70998L2.70998 11.3C2.31998 11.69 2.31998 12.32 2.70998 12.71L7.29998 17.3C7.68998 17.69 8.31998 17.69 8.70998 17.3C9.09998 16.91 9.09998 16.28 8.70998 15.89L5.82998 13H20C20.55 13 21 12.55 21 12V7.99998C21 7.44998 20.55 6.99998 20 6.99998C19.45 6.99998 19 7.44998 19 7.99998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-keyboard-return`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconKeyboardReturn

    ```js
    <b-new-b-icon-keyboard-return />
    ```
</docs>


